// JA選択ポップアップ
import React, { useState, useEffect } from 'react';
import { Modal, Button, FormControl, Form } from 'react-bootstrap';
import Heading from './Heading';
import { prefectures, convert_types } from '../Const';
import axios from '../axios';
import { convertData } from '../Convert';
import ValidMessage from '../atoms/ValidMessage';
import LoadingModal from '../molecules/LoadingModal';
import { authErrorTimeout } from '../Common';

interface Props {
  toggleShow: boolean;
  toggleClose: React.MouseEventHandler;
  popupClick: (ja_info: { ident_lv2_cd: string; name: string }) => void;
}

const SelectJa: React.FC<Props> = ({ toggleShow, toggleClose, popupClick }) => {
  const [prefecture_code, setPrefectureCode] = useState('');
  const [ja_name_kana, setJaNameKana] = useState('');
  const [ja_list, setJaList] = useState({});
  const [error_message, setErrorMessage] = useState('');
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    // 初期状態でJA一覧を全取得する
    handleClick();
  }, []);

  // 都道府県選択時の処理
  const handleChangePrefecture = (value: string) => {
    setPrefectureCode(value);
  };

  // JA名(カナ)入力時の処理
  const handleChangeJaNameKana = (value: string) => {
    setJaNameKana(value);
  };

  // フォーカスアウト時に半角カナに変換
  const handleBlur = (value: string) => {
    const convert_value = convertData(convert_types.change_hankaku_kana, value);
    setJaNameKana(convert_value);
  };

  // 検索ボタン押下時の処理
  const handleClick = async () => {
    try {
      // エラーメッセージ初期化
      setErrorMessage('');
      setIsLoading(true);
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/get_ja_list`,
        {
          prefecture_code: prefecture_code,
          ja_name_kana: ja_name_kana,
          ja_code: null,
        }
      );
      // 取得した情報をJA一覧に表示
      setJaList(response.data);
    } catch (error) {
      if (error.response.status === 422) {
        // エラーメッセージを格納
        setErrorMessage(error.response.data.message.ja_name_kana);
      }
      authErrorTimeout(error.response.status);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        size="lg"
        show={toggleShow}
        onHide={toggleClose}
        animation={false}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Heading label={'JA名選択'} size={'m'} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-input_wrapper">
            <div className="modal-input">
              <label>都道府県</label>
              <Form.Control
                as="select"
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                  handleChangePrefecture(event.target.value)
                }
              >
                <option value=""></option>
                {Object.entries(prefectures)
                  .sort((a, b) => Number(a[0]) - Number(b[0]))
                  .map(value => {
                    return (
                      <option value={value[0]} key={value[0]}>
                        {value[1]}
                      </option>
                    );
                  })}
              </Form.Control>
            </div>
            <div className="modal-input">
              <label>JA名(カナ)</label>
              <FormControl
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeJaNameKana(event.target.value)
                }
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleBlur(event.target.value)
                }
                value={ja_name_kana}
              />
              <ValidMessage message={error_message} />
            </div>
            <div className="modal-input">
              <Button size={'sm'} variant={'success'} className="btn-form" onClick={handleClick}>
                検索
              </Button>
            </div>
          </div>
          <Heading label="JA一覧" size={'s'} />
          <table className="modal-table">
            <tbody>
              <tr>
                {Object.values(ja_list).map((value: any, index: number) => {
                  return (
                    <td onClick={() => popupClick(value)} key={index}>
                      {value.name}
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
      <LoadingModal show={is_loading} />
    </>
  );
};

export default SelectJa;
